export default __webpack_public_path__ + "static/media/sensotrend_uploader_location.8d8e6051.png";